<div class="modal-header">
  <h3 class="mb-0">Set review status — {{ complianceStep }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="ViveProgressFormGroup">
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" for="vp-status">Status</label>
          <select
            id="vp-status"
            class="form-select"
            (ngModelChange)="statusChanged($event)"
            formControlName="status"
          >
            @for (status of Statuses; track status) {
              <option [ngValue]="status">{{ status }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" for="vp-subStatus">Sub-status</label>
          <select
            id="vp-subStatus"
            class="form-select"
            formControlName="subStatus"
          >
            @for (subStatus of SubStatuses; track subStatus) {
              <option [ngValue]="subStatus">{{ subStatus }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group mb-0">
          <label class="form-label" for="vp-ticketUrl">Ticket URL</label>
          <input
            id="vp-ticketUrl"
            type="text"
            class="form-control"
            formControlName="ticketUrl"
            placeholder="https://..."
          />
        </div>
      </div>
    </div>
  </form>

  @if (NoteFormGroup) {
    <form [formGroup]="NoteFormGroup" class="mt-4 pt-4 vp-note-section">
      <div class="vp-note-header">
        <h4 class="mb-0">Add a note</h4>
      </div>
      <div class="row g-3">
        <div class="col-12">
          <div class="form-group mb-0">
            <label class="form-label" requiredAsterisk for="vp-noteTitle">
              Title
            </label>
            <input
              id="vp-noteTitle"
              type="text"
              class="form-control"
              formControlName="title"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group mb-0">
            <label class="form-label" requiredAsterisk for="vp-noteBody">
              Note
            </label>
            <textarea
              id="vp-noteBody"
              class="form-control"
              rows="4"
              formControlName="note"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
